import MobileOpportunity from './MobileOpportunity'

export default MobileOpportunity
